module.exports = "<div class=\"row question-context-container\">\n  <div class=\"col-xs-12\">\n    <ng-template mpQuestionContextHost></ng-template>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mprep/shared/lib/angular/components/question-view/question-context-view/question-context-view.html
// module id = rTf6
// module chunks = 3